import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@unicup-ticketing/auth';

@Component({
  imports: [RouterModule],
  selector: 'ticketing-orbit',
  templateUrl: './ticketing-orbit.component.html',
  styleUrl: './ticketing-orbit.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketingOrbitComponent implements OnInit {
  private readonly auth = inject(AuthService);

  private readonly _elementRef = inject(ElementRef);

  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute('ng-version');
  }
}
